import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat.service';
import { DetalhesContatoChatComponent } from '../detalhes-contato-chat/detalhes-contato-chat.component';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { VisualizadorArquivosComponent } from '../visualizador-arquivos/visualizador-arquivos.component';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
declare let moment: any;

@Component({
  selector: 'app-chat-historico-unificado',
  templateUrl: './chat-historico-unificado.component.html',
  styleUrls: ['./chat-historico-unificado.component.scss']
})
export class ChatHistoricoUnificadoComponent implements OnInit, OnDestroy, AfterViewInit{
  @Input() historico_chat;
  @Input() provider_id;
  chatSelecionado: any;
  mensagensChat: any = [];
  newSubs: Subscription;
  locked: boolean = true;
  seeMoreTranscriptionUniqueIds = [];
  transcriptionUniqueIds = [];
  transcriptions = [];
  pagina: number = 1;
  mais_registros: boolean = false;

  @ViewChild("scrollMe") private myScrollContainer: ElementRef;

  constructor(
    private chatService: ChatService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.abrirChat();
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
    document.removeEventListener('click', this.eventListenerTranscription);
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', this.eventListenerTranscription);
  }

  abrirChat() {
    this.chatSelecionado = this.historico_chat;
    this.historico_chat.selecionado = true;
    let payload = {
      pagina: this.pagina,
      contato_id: this.historico_chat.contato_id
    };

    this.newSubs = this.chatService.buscarListaConversasContato(payload)
      .subscribe({
        next: (results) => {
          if(results) {
            let _msgs = results.chat.listaMensagens.map(msg => this.formatBodyMsg(msg, (msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' || msg.is_tranferencia) ? 'interno' : 'externo'));
            var response = {
              chat: {
                data_chat: results.chat.data_chat,
                listaMensagens: _msgs,
                mais_registros: results.chat.mais_registros
              }
            };
  
            this.mais_registros = response.chat.mais_registros;
  
            this.mensagensChat.push(response.chat);
          }
        }
      });
  }

  carregarMaisConversas(): void {
    let oldHeight = this.myScrollContainer.nativeElement.scrollHeight;
    this.pagina += 1;
    let payload = {
      pagina: this.pagina,
      contato_id: this.historico_chat.contato_id
    };
    this.newSubs = this.chatService.buscarListaConversasContato(payload)
      .subscribe({
        next: (results) => {
          if(results) {
            let _msgs = results.chat.listaMensagens.map(msg => this.formatBodyMsg(msg, (msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' || msg.is_tranferencia) ? 'interno' : 'externo'));
            var response = {
              chat: {
                data_chat: results.chat.data_chat,
                listaMensagens: _msgs,
                mais_registros: results.chat.mais_registros
              }
            };

            this.mais_registros = response.chat.mais_registros;

            this.mensagensChat.unshift(response.chat);
            setTimeout(() => {
              this.myScrollContainer.nativeElement.scrollTop += (this.myScrollContainer.nativeElement.scrollHeight - oldHeight);
            }, 50);
          }
        }
      });
  }

  abrirInfoContato(chat: any) {
    const modalRef = this.modalService.open(DetalhesContatoChatComponent, {
      scrollable: false,
      windowClass: "modal-custom-milvus",
      size: "medio",
      keyboard: false,
      backdrop: "static",
    });
    modalRef.componentInstance.chatData = chat;
    modalRef.result.then((result) => { });
  }

  close(result?) {
    this.activeModal.close();
  }

  scrollToBottom(): void {
    if (this.locked) {
      try {
        this.myScrollContainer.nativeElement.scrollTop =
          this.myScrollContainer.nativeElement.scrollHeight + 20;
      } catch (err) { }
    }
  }

  goToBottom(): void {
    this.myScrollContainer.nativeElement.scroll({
      top: this.myScrollContainer.nativeElement.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  }

  onScroll(event) {
    this.locked = false;
  }

  verificaMostraScrollBtn(): boolean {
    return (this.myScrollContainer?.nativeElement.scrollHeight - this.myScrollContainer?.nativeElement.scrollTop) > 500;
  }

  openTicket(ticket): void {
    var url = location.origin + "/tickets/details/" + ticket.id;
    window.open(url, "_blank");
  }

  formatBodyMsg(msg, source, newMsg?): any {

    let theme = "msg-resposta"

    if(localStorage.getItem("theme")){
       theme = localStorage.getItem("theme") == "light" ? "msg-resposta" : "msg-resposta-dark";
    }

    if(this.chatSelecionado.is_whatsapp && msg.tipo !== 'anexo') {
      let msg_content = this.applyWppFormat(msg.body || msg.msg);
      if(msg.body) {
        msg.body = msg_content;
      } else if(msg.msg) {
        msg.msg = msg_content;
      }
    }

    let messageParsed = msg.body || msg.msg || '';
    messageParsed = (messageParsed !== '') ? messageParsed.split(".") : messageParsed;

    let messageParsed_resposta = msg.resposta_message || '';
    messageParsed_resposta = (messageParsed_resposta !== '') ? messageParsed_resposta.split(".") : messageParsed_resposta;

    let horario = "";
    let horario_resposta = "";

    let mensagemErro = msg.erro_envio ?
      `<div class="d-flex align-items-center gap-2">
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.70312 2.04297C9.76562 1.9375 9.87891 1.875 10 1.875C10.1211 1.875 10.2344 1.9375 10.2969 2.04297L18.043 14.7656C18.0977 14.8555 18.125 14.957 18.125 15.0586C18.125 15.3711 17.8711 15.625 17.5586 15.625H2.44141C2.12891 15.625 1.875 15.3711 1.875 15.0586C1.875 14.9531 1.90234 14.8516 1.95703 14.7656L9.70312 2.04297ZM8.10156 1.06641L0.355469 13.7891C0.121094 14.1719 0 14.6094 0 15.0586C0 16.4062 1.09375 17.5 2.44141 17.5H17.5586C18.9062 17.5 20 16.4062 20 15.0586C20 14.6094 19.875 14.1719 19.6445 13.7891L11.8984 1.06641C11.4961 0.40625 10.7773 0 10 0C9.22266 0 8.50391 0.40625 8.10156 1.06641ZM11.25 13.125C11.25 12.7935 11.1183 12.4755 10.8839 12.2411C10.6495 12.0067 10.3315 11.875 10 11.875C9.66848 11.875 9.35054 12.0067 9.11612 12.2411C8.8817 12.4755 8.75 12.7935 8.75 13.125C8.75 13.4565 8.8817 13.7745 9.11612 14.0089C9.35054 14.2433 9.66848 14.375 10 14.375C10.3315 14.375 10.6495 14.2433 10.8839 14.0089C11.1183 13.7745 11.25 13.4565 11.25 13.125ZM10.9375 5.9375C10.9375 5.41797 10.5195 5 10 5C9.48047 5 9.0625 5.41797 9.0625 5.9375V9.6875C9.0625 10.207 9.48047 10.625 10 10.625C10.5195 10.625 10.9375 10.207 10.9375 9.6875V5.9375Z" fill="#FF0000"/>
        </svg>
        <div>Erro: ${msg.erro_envio}</div>
      </div></br>
      `
      : "";

    if (mensagemErro) {
      let mensagemTotal = mensagemErro + messageParsed
      msg.body = mensagemTotal;
    }
    
    if(msg.msg_legenda) {
      msg.msg_legenda = this.applyWppFormatLegend(msg.msg_legenda);
    }

    if (source === 'interno') {
      horario +=
        '<div class="text-left"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
        moment(msg.data_mensagem ? msg.data_mensagem : msg.data).format('DD/MM/YYYY HH:mm:ss') +
        "</span>";

      horario_resposta +=
        '<div class="text-left"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
        moment(msg.resposta_message_data ? msg.resposta_message_data : msg.data).format('DD/MM/YYYY HH:mm:ss') +
        "</span>";

      horario += this.setSendAndRead(msg);

      horario_resposta += this.setSendAndRead(msg);
    } else {
      let formatedHour;
      let formatedHour_resposta;
      if (msg.tipo === 'anexo' && newMsg) {
        console.log('msg anexo', msg, newMsg);
        formatedHour = moment().format('DD/MM/YYYY HH:mm:ss');
        formatedHour_resposta = moment().format('DD/MM/YYYY HH:mm:ss');
      } else {
        formatedHour = moment(msg.data_mensagem).format('DD/MM/YYYY HH:mm:ss');
        formatedHour_resposta = moment(msg.resposta_message_data).format('DD/MM/YYYY HH:mm:ss');
      }

      if(!msg.msg_legenda){
      horario += '<div class=" text-right"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
        formatedHour +
        "</span>";
      }

      horario_resposta += '<div class=" text-right"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
      formatedHour_resposta +
        "</span>";
    }

    let respostaMessage = msg.resposta_message ? 
    `<div><div class="${theme}"> ${ msg.resposta_message + horario_resposta}</div></div>` : '';


    if (msg.status_mensagem === 4 && msg.error_msg) {
      const errorHtml = `
        <div class="error-message">
          <div class="error-header">
            <i class="fa-regular fa-triangle-exclamation"></i>
            <span>Erro: ${msg.error_code} - ${msg.error_msg}</span>
          </div>
          <div>
            <span class="msg-body">${messageParsed}</span>
            <br/>
            <span class="msg-time">${horario}</span>
          </div>
        </div>
      `;
      msg.formatedBody = this.sanitizer.bypassSecurityTrustHtml(errorHtml);
      return;
    }

    if (messageParsed.length > 1) {
      if(messageParsed_resposta.length > 1) {
        msg.formatedBody = this.sanitizer.bypassSecurityTrustHtml(`<div class='${theme}'>` + this.setMediaMsg(msg.resposta_message, messageParsed_resposta, source, msg) + horario_resposta + "</div></div><div>" + this.setMediaMsg((msg.body) ? msg.body : msg.msg, messageParsed, source, msg) + horario + "</div>");
      }else{
        msg.formatedBody = this.sanitizer.bypassSecurityTrustHtml(respostaMessage + this.setMediaMsg((msg.body) ? msg.body : msg.msg, messageParsed, source, msg) + horario);
      }
    } else {
      if (messageParsed_resposta.length > 1) {
        msg.formatedBody = this.sanitizer.bypassSecurityTrustHtml(`<div class='${theme}'>` + this.setMediaMsg(msg.resposta_message, messageParsed_resposta, source, msg) + horario_resposta +  "</div></div><div>" + ((msg.body) ? msg.body : msg.msg) + horario + "</div>");
      } else {
        msg.formatedBody = this.sanitizer.bypassSecurityTrustHtml(respostaMessage + ((msg.body) ? msg.body : msg.msg) + horario);
      }
    }
    
    return msg;
    // this.mensagensChat
    //   .forEach(
    //     chat => {
    //       chat.listaMensagens.forEach(mensagem => {
    //         if (mensagem.message_id === msg.message_id) {
    //           mensagem = { ...mensagem, ...msg };
    //         }
    //       });
    //     });
  }

  setSendAndRead(msg): string {
    // status_envio_id
    const audioExtensions = [".mp3", ".wav", ".ogg", ".flac", ".aac", ".m4a"];
    if (msg && msg.message && msg.tipo === 'anexo' && audioExtensions.some(extension => msg.message.endsWith(extension))) {
      switch (msg.status_envio_id) {
        case 0:
          return '<span class="error-time">&nbsp&nbspx</span></div>';
        case 1:
          return '<span class="read-time"><i class="fa-regular fa-clock" style="font-size: 12px; margin-left: 8px;"></i></span></div>';
        case 2:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
        case 3:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        case 4:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        case 5:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        default:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
      }
    } else if(this.provider_id === 4) {
      switch (msg.status_mensagem) {
        case 1:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
        case 2:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        case 3:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        case 4:
          return '<span class="error-time">&nbsp&nbspx</span></div>';
        case 5:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        default:
          return "</div>";
      }
    } else {
      switch (msg.status_envio_id) {
        // case 1:
        //   return '<span class="read-time"><i class="fa-regular fa-clock" style="font-size: 12px; margin-left: 8px;"></i></span></div>';
        case 1:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
        case 3:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        case 4:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        case 5:
          return '<span class="check-time">&nbsp&nbspx</span></div>';
        default:
          return "</div>";
      }
    }
  }
  
  setMediaMsg(msg_body, messageParsed, source, msg): string {
    let format = messageParsed[messageParsed.length - 1];
    let linkcheck = msg_body.split("https:");
    let linkcheckS = msg_body.split("http:");

    switch (format) {
      case "png":
      case "jpg":
      case "jpeg":
      case "bmp":
        return (
          '<a target="_blank" href="' +
          msg_body +
          '"><img width="400" height="300"  src="' +
          msg_body +
          '" /></a>'
        );
      case "opus":
      case "mp3":
      case "ogg":
      case "wav":
      case "oga":
      case "mpeg":
        if (source !== 'interno' && msg.resumo_audio && msg.transcricao_audio) {
          return (
            "<audio controls><source src=" +
            msg_body +
            ' type="audio/mpeg"></audio><br><a target="_blank" href="' +
            msg_body +
            '">download </a>' + this.transcriptAudio(msg)
          );
        } else {
          return (
            "<audio controls><source src=" +
            msg_body +
            ' type="audio/mpeg"></audio><br><a target="_blank" href="' +
            msg_body +
            '">download </a>'
          );
        }
      case "mp4":
        if (msg_body.includes('audio_')) {
          return (
            "<audio controls><source src=" +
            msg_body +
            ' type="audio/mp4"></audio><br><a target="_blank" href="' +
            msg_body +
            '">download </a>'
          );
        } else {
          return (
            '<video width="400" height="300" controls><source src="' +
            msg_body +
            '" type="video/mp4"></video><br><a target="_blank" href="' +
            msg_body +
            '">download </a>'
          );
        }
      case "zip":
      case "rar":
      case "msi":
        if (linkcheck.length > 1 || linkcheckS.length > 1) {
          return (
            '<a target="_blank" href="' +
            msg_body +
            '">' +
            this.translate.instant("CLIQUE_AQUI_BAIXAR") +
            "</a>"
          );
        } else {
          return msg_body;
        }
      default:
        let index = msg_body.indexOf("http");
        if (index !== -1) {
          msg_body
            .split(" ")
            .filter((item) => item.includes("http"))
            .forEach((element) => {
              msg_body = msg_body.replace(element, `<a target="_blank" href="${element}">${element}</a>`);
            });
          return msg_body;
        } else {
          return msg_body;
        }
    }
  }

  transcriptAudio(msg): string {
    let returnedHtml =
      '<div class="transcription-audio"><span><img class="pr-2" src="assets/img/general/icon_openai_milvus.png" width="50">' +
      this.translate.instant('RESUMO_AUDIO') + '</span>' +
      '<span>' + msg.resumo_audio + '</span>' +
      '<span class="pt-2">' + this.translate.instant('TRANSCRICAO_COMPLETA') + '<span class="ml-2" id="' + this.generateUniqueIdTranscription(msg) + '"></span>' + '<span id="' +
      this.generateUniqueIdSeeMore() + '" class="see-more-transcription pl-2">' + this.translate.instant('VER_MAIS') + '</span></div>';
    return returnedHtml;
  }

  generateUniqueIdSeeMore(): string {
    let uniqueId = 'smtc' + Math.random().toString(36).substring(2);
    this.seeMoreTranscriptionUniqueIds.push(uniqueId);
    return uniqueId;
  }

  generateUniqueIdTranscription(msg): string {
    let uniqueId = 'tc' + Math.random().toString(36).substring(2);
    this.transcriptionUniqueIds.push(uniqueId);
    this.transcriptions.push(msg.transcricao_audio);
    return uniqueId;
  }

  eventListenerTranscription = (event): void => {
    if (this.seeMoreTranscriptionUniqueIds.includes(event.target.id)) {
      let see_more_tag = document.getElementById(event.target.id);
      let tag_index = this.seeMoreTranscriptionUniqueIds.indexOf(event.target.id);
      let transcription_tag = document.getElementById(this.transcriptionUniqueIds[tag_index]);

      if (transcription_tag.innerHTML) {
        transcription_tag.innerHTML = '';
        see_more_tag.innerHTML = this.translate.instant('VER_MAIS');
      } else {
        transcription_tag.innerHTML = this.transcriptions[tag_index];
        see_more_tag.innerHTML = this.translate.instant('VER_MENOS');
      }
    }
  }

  visualizarArquivo(msg: any, event: Event) {
    let arquivo = '';
    event.preventDefault();
    
    if(msg.tipo !== 'texto') {
      if (msg && typeof msg === 'string') {
        arquivo = msg
      } else if(msg && msg.msg && msg.msg.match(/\.\w+$/)) {
        arquivo = msg.msg
      } else if (msg && msg.body && msg.body.match(/\.\w+$/)) {
        arquivo = msg.body
      } else if (msg && msg.resposta_message && msg.resposta_message.match(/\.\w+$/)) {
        arquivo = msg.resposta_message
      }
    } else if(event.target['localName'] === 'a') {
      arquivo = event.target['href'];
    } else {
      return;
    }

    if (!arquivo.match(/\.\w+$/)) {
      return;
    }

    if (
      arquivo.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) ||
      arquivo.match(/\.(mp3|wav|ogg)$/i) ||
      arquivo.match(/\.(mp4|webm|ogg|mov)$/i) ||
      arquivo.match(/\.pdf$/i)
    ) {
      const modalRef = this.modalService.open(VisualizadorArquivosComponent, {
        scrollable: false,
        windowClass: 'modal-custom-arquivos',
        size: 'grande',
        keyboard: true,
      });
  
      modalRef.componentInstance.fileUrl = arquivo;
    } else {
      this.baixarArquivo(arquivo);
    }
  }

  private baixarArquivo(fileUrl: string, fileName?: string): void {
    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        anchor.href = url;
        anchor.download = fileName || fileUrl.split('/').pop() || 'download.json';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(url);
      })
      .catch(error => console.error('Erro ao baixar arquivo:', error));
  }

  applyWppFormat(msgBody): string {
    if(msgBody[0] === '>') {
      let msgFormatted = msgBody.substring(1);
      msgBody = '<cite style="border-left: 3px solid gray; padding-left: 4px; display: block; opacity: 0.8;">' + msgFormatted + '</cite>';
    } else if(msgBody[0] === '-' && msgBody[1] === ' ') {
      msgBody = '<ul>' + msgBody.replaceAll('- ', '• ') + '</ul>';
    } else if(msgBody[0] === '*' && msgBody[1] === ' ') {
      msgBody = '<ul>' + msgBody.replaceAll('* ', '• ') + '</ul>';
    } else if(msgBody[0] === '1' && msgBody[1] === '.') {
      msgBody = '<ul>' + msgBody + '</ul>';
    }

    msgBody = msgBody.replace('```', '<samp>');
    msgBody = msgBody.replace('```', '</samp>');

    let formatacoes_possiveis = {
      negrito: null,
      italico: null,
      codigo: null,
      rasurado: null
    };

    for(let i = 0; i < msgBody.length; i++) {
      switch(msgBody[i]) {
        case '*':
          if(formatacoes_possiveis.negrito !== null) {
            msgBody = this.replaceAt(msgBody, formatacoes_possiveis.negrito, '<b>');
            msgBody = this.replaceAt(msgBody, (i + 2), '</b>');
            formatacoes_possiveis.negrito = null;
          } else {
            formatacoes_possiveis.negrito = i;
          }
          break;
        case '_':
          if(formatacoes_possiveis.italico !== null) {
            msgBody = this.replaceAt(msgBody, formatacoes_possiveis.italico, '<i>');
            msgBody = this.replaceAt(msgBody, (i + 2), '</i>');
            formatacoes_possiveis.italico = null;
          } else {
            formatacoes_possiveis.italico = i;
          }
          break;
        case '~':
          if(formatacoes_possiveis.rasurado !== null) {
            msgBody = this.replaceAt(msgBody, formatacoes_possiveis.rasurado, '<del>');
            msgBody = this.replaceAt(msgBody, (i + 4), '</del>');
            formatacoes_possiveis.rasurado = null;
          } else {
            formatacoes_possiveis.rasurado = i;
          }
          break;
        case '`':
          if(msgBody[i - 1] !== '`' && msgBody[i + 1] !== '`') {
            if(formatacoes_possiveis.codigo !== null) {
              msgBody = this.replaceAt(msgBody, formatacoes_possiveis.codigo, '<code>');
              msgBody = this.replaceAt(msgBody, (i + 5), '</code>');
              formatacoes_possiveis.codigo = null;
            } else {
              formatacoes_possiveis.codigo = i;
            }
          } 
          break;
      }
    };

    return msgBody;
  }

  applyWppFormatLegend(msgBody): string {
    return this.applyWppFormat(msgBody);
  }

  replaceAt(string, index, replacement) {
    let firstPart = string.substr(0, index);
    let lastPart = string.substr(index + 1);
    let newString = firstPart + replacement + lastPart;
    return newString;
  }
}
